import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedWorkoutTemplateListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseWorkoutTemplates {
  search?: string;
  ordering?: string;
  limit?: string;
}

function useWorkoutTemplates({
  search,
  ordering,
  limit = '20',
}: IUseWorkoutTemplates = {}): UseInfiniteQueryResult<AxiosResponse<PaginatedWorkoutTemplateListList>> {
  const fetchWorkoutTemplates = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedWorkoutTemplateListList>> => {
      const params: UrlParams = { ...pageParam };

      if (search) {
        params.search = search;
      }

      if (ordering) {
        params.ordering = ordering;
      }

      return client.get(`workout-templates/?${encodeUrlParams(params)}`);
    },
    [limit, ordering, search],
  );

  return useInfiniteQuery(['workoutTemplates', search, ordering], fetchWorkoutTemplates, {
    getNextPageParam: page => (page.data.next ? urlParamsFromUrl(page.data.next) : undefined),
  });
}

export default useWorkoutTemplates;
